import { ErrorMessage as FormikErrorMessage } from 'formik';
import React from 'react';

import { StyledErrorContainer } from './error-message.styled';

const StyledErrorMessage: React.FC<{ name: string }> = ({ name }) => (
  <StyledErrorContainer>
    <FormikErrorMessage name={name} />
  </StyledErrorContainer>
);

export default StyledErrorMessage;